import useDemoHelper from "./useDemoHelper";
import step31 from "../../../../../assets/demo/emergency/3.1.mp3";
import step32 from "../../../../../assets/demo/emergency/3.2.mp3";

window.sound = new Audio();

export default function () {
    const demoHelper = useDemoHelper();

    const flashPictureBefore = () => {
        demoHelper.flash('[data-test="button-emergency-picture"]', 5);
    }


    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 6 seconds
            window.sound.src = step31;
            window.sound.play();

            await demoHelper.sleep(2000);

            flashPictureBefore();

            await demoHelper.sleep(5000);

            // 3 seconds
            window.sound.src = step32;
            window.sound.play();

            await demoHelper.sleep(2500);

            demoHelper.unlockInteract();
        }
    }
}